import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_sr_gen_ai_summary_v3_ddot",
  stages: {
    direct: 2,
    meta: 3,
    us: 4,
    shortHaul: 5,
    mediumHaul: 6,
    longHaul: 7,
    children: 8,
    ctaClicked: 9
  },
  goals: {
    success: 1,
    error: 2,
    ctaClick: 3
  },
  defaultStage: 1
});

const useTrackStages = () => {
  const { stages } = utils;
  const { isAmerican, isDirect, isMeta, isShortHaul, isMediumHaul, isLongHaul, isWithKids } = useProfiler();

  useEffect(() => {
    isDirect() && stages.direct();
    isMeta() && stages.meta();
    isAmerican() && stages.us();

    isShortHaul() && stages.shortHaul();
    isMediumHaul() && stages.mediumHaul();
    isLongHaul() && stages.longHaul();

    isWithKids() && stages.children();
  }, [stages, isAmerican, isDirect, isMeta, isWithKids, isShortHaul, isMediumHaul, isLongHaul]);
};

export default { ...utils, useTrackStages };
